
















import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    image: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    alt: {
      type: String,
      default: '',
    },
    titleComponent: {
      type: String,
      default: 'h1',
    },
    loading: {
      type: String,
      default: 'eager',
    },
  },
  setup () {
    return {}
  },
})
